// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class FormView extends JQueryView {
  hasShared: boolean;

  constructor(hasShared: boolean) {
    super('#form_area');
    this.hasShared = hasShared;
    this.render();
  }

  showCapitalPolicyArea() {
    $('.select-cp-area').removeClass('d-none');
    $('.sharing-button').addClass('active');
    $('.unsharing-button').removeClass('active');
  }

  hideCapitalPolicyArea() {
    $('.select-cp-area').addClass('d-none');
    $('.sharing-button').removeClass('active');
    $('.unsharing-button').addClass('active');
  }

  render() {
    if (this.hasShared) {
      this.showCapitalPolicyArea();
    } else {
      this.hideCapitalPolicyArea();
    }
  }

  @on({ event: 'click', selector: '.unsharing-button' })
  onChangeUnsharing() {
    this.hideCapitalPolicyArea();
  }

  @on({ event: 'click', selector: '.sharing-button' })
  onChangeSharing() {
    this.showCapitalPolicyArea();
  }

  @on({
    event: 'change',
    selector: '#company_investor_document_group_shared_capital_policy_id',
  })
  onChangeSharingCp() {
    $('.sharing-button').trigger('click');
    this.showCapitalPolicyArea();
  }
}
